import { createApp } from 'vue';
import App from './App.vue';
import router from './router/index.js';
import './assets/components/main.scss';
// import axios from 'axios';
// import Cookies from "js-cookie";
import setupInterceptors from "./services/setupInterceptors.js";
import "vue3-toastify/dist/index.css";
import 'vuetify/styles';
import 'vuetify/dist/vuetify.css';
import 'vuetify/dist/vuetify.min.css';
import { createPinia } from "pinia";
import '@mdi/font/css/materialdesignicons.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Vue3Toastify from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
// import vue3GoogleLogin from 'vue3-google-login'
import vuetify from './plugins/vuetify.js'

// import translator from '@/util/translation';
import { translations } from '@/store/translations'
import { createI18n } from 'vue-i18n'
// import langObj from "./util/lang.json";
const pinia = createPinia();

// axios.defaults.baseURL = 'http://localhost:8000/api';
// axios.defaults.withCredentials = true;
//
const app = createApp(App);
// app.config.globalProperties.$axios = axios;
// axios.interceptors.request.use(config => {
//     const token = Cookies.get('auth_token');
//     if (token) {
//         config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
// });

const i18n = createI18n({
    legacy: false,
    locale: 'en',
    fallbackLocale: 'en',
    messages: translations,
    globalInjection: true // Enable $t in Options API
})
// let gauthClientId = '676785461988-icoil0dtlld2fcp5kb22llst7t94mans.apps.googleusercontent.com';
app.use(pinia)
    .use(vuetify)
    .use(router)
    .use(i18n)
 
    .use(Vue3Toastify, {
        autoClose: 3000,
        position: 'top-right',
        transition: 'Vue-Toastification__bounce',
    });
        app.mount('#app'); // Mount even if translations fail
    // });
setupInterceptors();